<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="responses && responses.length > 0; else noTableData">
    <div class="text-center mb-4 fw-200">{{ totalResponses }} Submissions</div>
    <p class="text-center text-muted mb-3">
      Viewing individual file responses to this question
    </p>
    <div class="card attachment-card">
      <div
        class="attachment-answer"
        *ngFor="let response of responses; let i = index">
        <div id="response-{{ fieldId }}-{{ i }}" class="response-container">
          <div class="filedata d-flex justify-content-start align-items-center">
            <i class="bi-file-image me-2"></i>
            <div class="filename">
              {{ response.text_answer | filenameOnly }}
            </div>
          </div>
          <div class="action-buttons">
            <button
              ngbTooltip="View file"
              aria-label="View file"
              class="btn"
              (click)="viewFile(response.text_answer)">
              <i [ngClass]="['bi', 'fs-21', 'bi-eye']"></i>
            </button>
            <button
              ngbTooltip="Download file"
              aria-label="Download file"
              class="btn"
              (click)="downloadFile(response.text_answer)">
              <i [ngClass]="['bi', 'fs-21', 'bi-download']"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="w-100" style="height: 300px; position: relative">
    <app-loader />
  </div>
</ng-template>

<ng-template #noTableData>
  <div class="text-center py-3">No Responses Found.</div>
</ng-template>

<section>
  <div class="d-flex justify-content-center my-4">
    <ngb-pagination
      *ngIf="totalResponses > 5"
      [(page)]="currentPage"
      [pageSize]="5"
      [collectionSize]="totalResponses"
      [maxSize]="5"
      (pageChange)="paginationChange()"></ngb-pagination>
  </div>
</section>
